import(/* webpackMode: "eager", webpackExports: ["ExampleLoader"] */ "/home/runner/_work/landfolk/landfolk/apps/design-system/app/[examples]/[example]/_components/example-loader.tsx");
